// core
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

// campfire
import { MaterialModule } from '@campfire-nx/material';
import { OpenModule } from '@campfire-nx/open';

// open-portal
import { ReferRoutingModule } from './refer-routing.module';
import { LandingComponent } from './landing/landing.component';
import { ComparisonModalComponent } from './components/modals/comparison-modal/comparison-modal.component';
import { ReferGenericCarComponent } from './components/refer-generic-car/refer-generic-car.component';
import { ReferGenericTravelComponent } from './components/refer-generic-travel/refer-generic-travel.component';
import { ReferAhmComponent } from './components/refer-ahm/refer-ahm.component';
import { AhmComparisonModalComponent } from './components/modals/ahm-comparison-modal/ahm-comparison-modal.component';
import { ComponentsModule } from '@open-portal-app/components/components.module';


@NgModule({
  declarations: [
    LandingComponent,
    ComparisonModalComponent,
    ReferGenericCarComponent,
    ReferGenericTravelComponent,
    ReferAhmComponent,
    AhmComparisonModalComponent
  ],
  imports: [
    CommonModule,
    ReferRoutingModule,
    MaterialModule,
    OpenModule,
    ComponentsModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReferModule { }
